(()=>{
'use strict';
if(window.AWOccasionGarageP229?.version)return;
const VERSION='2.29.0';
const K={
  replicas:'aw_garage_replicas_v1',
  timeline:'aw_upgrade_timeline_v1',
  tombstones:'aw_garage_tombstones_v1',
  registry:'aw_occasion_garage_identity_v1'
};
let applying=false;
const text=v=>String(v??'').trim();
const arr=v=>Array.isArray(v)?v:[];
const read=(k,f)=>{try{const v=JSON.parse(localStorage.getItem(k)||'null');return v??f}catch(_){return f}};
const write=(k,v)=>{try{localStorage.setItem(k,JSON.stringify(v));return true}catch(_){return false}};
const numId=v=>{const m=text(v).match(/(\d+)$/);return m?m[1]:''};
const dateOnly=v=>{const s=text(v);return /^\d{4}-\d{2}-\d{2}/.test(s)?s.slice(0,10):''};
const sourceNodes=()=>[...document.querySelectorAll('script[data-aw-owned-passport-code]')];
const parse=node=>{try{const v=JSON.parse(node?.textContent||'{}');return v&&typeof v==='object'?v:null}catch(_){return null}};
const dispatch=(replicaId,reason)=>{
  window.dispatchEvent(new CustomEvent('aw:p2-garage-updated',{detail:{source:'p2.29-occasion-garage',replicaId,reason}}));
  window.dispatchEvent(new CustomEvent('aw:replica-dossier-updated',{detail:{source:'p2.29-occasion-garage',replicaId,reason}}));
};
function identityFrom(payload){
  if(!payload?.replicaId||!payload?.awNumber||!payload?.modelHandle||!payload?.model)return null;
  const gid=text(payload.occasionProductId||payload.productId);
  return {
    replicaId:text(payload.replicaId),
    awNumber:text(payload.awNumber),
    modelHandle:text(payload.modelHandle),
    model:text(payload.model),
    manufacturer:text(payload.manufacturer),
    platform:text(payload.platform),
    type:text(payload.type),
    productGid:gid,
    productId:numId(gid),
    soldAt:text(payload.soldAt),
    passportReference:text(payload.passportReference),
    sourceKind:'occasion_aw'
  };
}
function collect(){
  const current=read(K.registry,{});
  const registry=current&&typeof current==='object'&&!Array.isArray(current)?current:{};
  let changed=false;
  sourceNodes().forEach(node=>{
    const id=identityFrom(parse(node));
    if(!id)return;
    const old=registry[id.replicaId]||{};
    const next={...old,...id,seenAt:old.seenAt||new Date().toISOString()};
    if(JSON.stringify(old)!==JSON.stringify(next)){registry[id.replicaId]=next;changed=true}
  });
  if(changed)write(K.registry,registry);
  return registry;
}
function ensurePurchaseEvent(timeline,id){
  const eventId=`occasion-purchase-${id.productId||id.awNumber.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`;
  const event={
    id:eventId,
    replicaId:id.replicaId,
    type:'purchase_order',
    title:'Réplique AW Occasion Airsoft achetée',
    notes:`Passeport ${id.awNumber} · modèle canonique AW rattaché. Configuration réelle à compléter dans Mon Atelier.`,
    date:dateOnly(id.soldAt)||new Date().toISOString().slice(0,10),
    source:'shopify',authority:'server',
    productId:id.productId,productGid:id.productGid,
    active:true,awNumber:id.awNumber,
    createdAt:id.soldAt||new Date().toISOString()
  };
  const idx=timeline.findIndex(e=>text(e?.id)===eventId);
  if(idx>=0)timeline[idx]={...timeline[idx],...event};else timeline.unshift(event);
  return timeline.filter((e,i)=>{
    if(i===timeline.findIndex(x=>text(x?.id)===eventId))return true;
    return !(text(e?.replicaId)===id.replicaId&&text(e?.type)==='purchase_order'&&text(e?.source)==='aw_occasion_passport'&&text(e?.awNumber)===id.awNumber);
  });
}
function apply(reason='refresh'){
  if(applying)return false;
  applying=true;
  try{
    const registry=collect();
    const ids=Object.values(registry).filter(x=>x&&x.replicaId&&x.modelHandle&&x.awNumber);
    if(!ids.length)return false;
    let replicas=arr(read(K.replicas,[]));
    let timeline=arr(read(K.timeline,[]));
    let tombstones=arr(read(K.tombstones,[]));
    let changed=false;
    const now=new Date().toISOString();
    ids.forEach(id=>{
      const idx=replicas.findIndex(r=>text(r?.id)===id.replicaId);
      const prior=idx>=0&&replicas[idx]&&typeof replicas[idx]==='object'?replicas[idx]:{};
      if(text(prior.modelHandle)&&text(prior.modelHandle)!==id.modelHandle){
        console.warn('[AW P2.29] Identité AW Occasion Airsoft locale divergente, identité canonique serveur restaurée.',id.replicaId);
      }
      const owned=[...new Set([...arr(prior.ownedProductIds).map(String),id.productId].filter(Boolean))];
      const next={
        ...prior,
        id:id.replicaId,
        nickname:text(prior.nickname)||`${id.model} · ${id.awNumber}`,
        manufacturer:id.manufacturer,
        model:id.model,
        platform:id.platform,
        type:id.type,
        modelHandle:id.modelHandle,
        acquiredAt:text(prior.acquiredAt)||dateOnly(id.soldAt),
        maintenanceMonths:Number(prior.maintenanceMonths||0),
        maintenanceDueDate:text(prior.maintenanceDueDate),
        ownedProductIds:owned,
        ownedVariantIds:arr(prior.ownedVariantIds),
        createdAt:text(prior.createdAt)||id.soldAt||now,
        updatedAt:text(prior.updatedAt)||now,
        certification:prior.certification&&typeof prior.certification==='object'?prior.certification:{status:'none',id:'',certifiedAt:'',source:''},
        awNumber:id.awNumber,
        occasionProductId:id.productId,
        occasionProductGid:id.productGid,
        sourceKind:'occasion_aw',
        source:'shopify_occasion_sale',
        authority:'server'
      };
      if(idx<0){replicas.unshift(next);changed=true}
      else if(JSON.stringify(prior)!==JSON.stringify(next)){replicas[idx]=next;changed=true}
      const before=JSON.stringify(timeline);
      timeline=ensurePurchaseEvent(timeline,id);
      if(JSON.stringify(timeline)!==before)changed=true;
      tombstones=tombstones.map(t=>{
        if(t?.entity==='replica'&&text(t?.id)===id.replicaId&&t?.supersededByServerOwnership!==true){
          changed=true;
          return {...t,supersededByServerOwnership:true,supersededAt:now};
        }
        return t;
      });
    });
    if(!changed)return false;
    write(K.replicas,replicas);write(K.timeline,timeline);write(K.tombstones,tombstones);
    ids.forEach(id=>dispatch(id.replicaId,reason));
    return true;
  }finally{applying=false}
}
function protectIdentity(){
  document.addEventListener('submit',event=>{
    const form=event.target.closest?.('[data-aw-garage-replica-form]');
    if(!form)return;
    const replicaId=text(form.dataset.editingId);if(!replicaId)return;
    const registry=collect();const id=registry[replicaId];if(!id)return;
    const set=(name,value)=>{const input=form.elements?.[name];if(input)input.value=value||''};
    set('manufacturer',id.manufacturer);set('model',id.model);set('platform',id.platform);set('replica_type',id.type);
    form.dataset.awP229IdentityLocked='true';
  },true);
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('[data-aw-replica-delete]');if(!button)return;
    const replicaId=text(button.dataset.awReplicaDelete);const registry=collect();
    if(!registry[replicaId])return;
    event.preventDefault();event.stopImmediatePropagation();
    window.alert('Cette réplique AW Occasion Airsoft est rattachée à votre passeport et à votre preuve de propriété. Elle ne peut pas être supprimée comme une fiche locale.');
  },true);
}
function start(){
  protectIdentity();
  apply('owned-passport-source');
  window.addEventListener('aw:p2-garage-updated',e=>{if(e?.detail?.source==='p2.29-occasion-garage')return;setTimeout(()=>apply('garage-update'),0)});
  window.addEventListener('aw:p2-cloud-data',()=>setTimeout(()=>apply('cloud-import'),0));
  window.addEventListener('aw:p22-server-state-applied',()=>setTimeout(()=>apply('server-state'),0));
  window.addEventListener('storage',e=>{if([K.replicas,K.timeline,K.tombstones].includes(e.key))setTimeout(()=>apply('storage'),0)});
  document.addEventListener('shopify:section:load',()=>setTimeout(()=>apply('section-load'),0));
}
window.AWOccasionGarageP229={version:VERSION,apply,collect,policy:'canonical-identity-server-locked;purchased-not-installed;customer-config-preserved;one-occasion-unit-one-replica'};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
